module.exports = __webpack_public_path__ + "static/img/lan-bg.b24ef6b.png";


//////////////////
// WEBPACK FOOTER
// ./src/layout/pages/home/images/lan-bg.png
// module id = 8No2
// module chunks = 4